import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TextInput, useMuiController } from "@sinch/components/index";

export const CreateIntervalDescriptionField: FC = () => {
  const { t } = useTranslation();
  const { field } = useMuiController({ name: "description" });
  return <TextInput maxRows={20} minRows={3} multiline {...field} fullWidth label={t("RateUnit.unitDescription")} />;
};
